(function ($) {

    /**
     * Beekman App Object
     *
     * This object contains all the custom javascript functionality for the Beekman site.
     */
    const beekman = {

        /**
         * Initializes the script.
         */
        init: function (settings) {
            console.log('Beekman JS Initialized.');
            console.log('Current page:', settings.page);
            // Init global functions:
            this.handleGlobalFunctions();
            // You can now run functions based on the page
            if (settings.page === 'product') {
                this.handleProductPage();
            }
        },

        /**
         * Handles global functions that are applicable across multiple pages.
         */
        handleGlobalFunctions: function () {
            console.log('Running Global Functions.');

            this.handleAddToCartLoggedIn();

            // --- UPDATED LOGIC ---
            // Call the new setup functions for fitment centre selection.
            this.handleCityMatchSelection();        // Sets up the default city name matching
            this.handleClosestDealershipClick();    // Sets up the "Find Closest" button
        },

        /**
         * Handles the add to cart functionality for logged-in users.
         */
        handleAddToCartLoggedIn: function () {
            // ... (Your existing code for this function remains unchanged)
            $(".beekmanLoggedInPopupButton").on('click', function (e) {
                if (!$(this).hasClass("beekmanLoggedIn")) {
                    e.preventDefault();
                    console.log('User is not logged in. Opening popup.');
                    if (typeof JetPopup !== 'undefined') {
                        JetPopup.open('LogInPopup');
                    } else {
                        jQuery(window).trigger({
                            type: 'jet-popup-open-trigger',
                            popupData: {
                                popupId: 'jet-popup-122377'
                            }
                        });
                    }
                    return false;
                }
            });
        },

        /**
         * Handles functionality specific to the product page.
         */
        handleProductPage: function () {
            console.log('Running Product Page specific JavaScript.');
            // Add your product page jQuery code here.
        },

        // --- NEW AND RESTRUCTURED FITMENT CENTRE FUNCTIONS START HERE ---

        /**
         * 1. DEFAULT BEHAVIOR: Sets up listeners to auto-select a fitment centre based on the city name entered.
         */
        handleCityMatchSelection: function () {
            const updateSelection = () => {
                const useShipping = $('#ship-to-different-address-checkbox').is(':checked');
                const shippingCity = $('#shipping_city').val();
                let cityToSearch = $('#billing_city').val();

                if (useShipping && shippingCity) {
                    cityToSearch = shippingCity;
                }

                if (cityToSearch) {
                    this.findDealershipByCityName(cityToSearch);
                }
            };
            $(document.body).on('change', '#billing_city, #shipping_city, #ship-to-different-address-checkbox', updateSelection);
        },

        /**
         * Helper that finds the first dealership in the list that starts with the given city name.
         */
        findDealershipByCityName: function (city) {
            const userInputCity = city.trim().toLowerCase();
            let bestMatchValue = '';

            $('#preferred_fitmentcentre option').each(function () {
                const optionText = $(this).text().trim().toLowerCase();
                if ($(this).val() !== '' && optionText.startsWith(userInputCity)) {
                    bestMatchValue = $(this).val();
                    return false; // Found the first match, break the loop
                }
            });

            if (bestMatchValue) {
                $('#preferred_fitmentcentre').val(bestMatchValue).trigger('change');
            }
        },

        /**
         * 2. NEW BEHAVIOR: Handles the "Find Closest" button click to run a geographic search.
         */
        handleClosestDealershipClick: function () {
            $(document.body).on('click', '#find-closest-dealership-btn', (e) => {
                e.preventDefault();
                const button = $(e.currentTarget);
                const resultSpan = $('#dealership-distance-result');

                const address = [
                    $('#billing_address_1').val(),
                    $('#billing_city').val(),
                    $('#billing_postcode').val()
                ].filter(Boolean).join(', ');

                if (!address) {
                    alert('Please fill in your address details first.');
                    return;
                }

                button.text('Searching...').prop('disabled', true);
                resultSpan.hide();

                this.findAndSelectClosestDealership(address, (closest) => {
                    if (closest.id) {
                        const roundedDistance = Math.round(closest.distance);
                        $('#preferred_fitmentcentre').val(closest.id.toString()).trigger('change');
                        resultSpan.text(`(Closest: ~${roundedDistance} km away)`).show();
                    } else {
                        resultSpan.text('(Could not find a match)').show();
                    }
                    button.text('📍 Use My Address to Find the Closest').prop('disabled', false);
                });
            });

            $(document.body).on('change', '#preferred_fitmentcentre', () => {
                $('#dealership-distance-result').hide();
            });
        },

        /**
         * Helper that takes an address, finds the closest dealership, and uses a callback.
         */
        findAndSelectClosestDealership: function (address, callback) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'address': address }, (results, status) => {
                if (status !== 'OK' || !results[0]) {
                    console.error('Geocode failed: ' + status);
                    callback({});
                    return;
                }

                const userLoc = results[0].geometry.location;
                let closest = { id: null, distance: Infinity };

                if (beekman_settings.dealerships) {
                    beekman_settings.dealerships.forEach(dealership => {
                        const distance = this.calculateDistance(userLoc.lat(), userLoc.lng(), dealership.lat, dealership.lng);
                        if (distance < closest.distance) {
                            closest = { id: dealership.id, distance: distance };
                        }
                    });
                }

                callback(closest);
            });
        },

        /**
         * Helper function to calculate distance between two coordinates.
         */
        calculateDistance: function (lat1, lon1, lat2, lon2) {
            const R = 6371; // Radius of the Earth in km
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
            const a =
                0.5 - Math.cos(dLat) / 2 +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                (1 - Math.cos(dLon)) / 2;
            return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        }

    }; // End of beekman object

    // When the document is ready, initialize the beekman app.
    $(document).ready(function () {
        if (typeof beekman_settings !== 'undefined') {
            beekman.init(beekman_settings);
        }
    });

})(jQuery);